exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:1366px){.page-results .grid-cards{padding:1rem 0}}.page-results .grid-cards.loading .col{flex-basis:100%}.page-results .empty-error{min-height:800px;min-height:calc(100vh - 475px)}.page-results .search-form form{flex-direction:column}@media (max-width:1023px){.page-results .search-form form>div{width:50%!important}.page-results .search-form form>div:not(:last-child){margin-bottom:10px}}@media (max-width:639px){.page-results .search-form form>div{width:100%!important}}@media (min-width:1024px){.page-results .search-form form{flex-direction:row}}", ""]);

// exports
exports.locals = {
	"navy": "#001d38",
	"turquoiseBlue": "#00adbc",
	"white": "#fff",
	"black": "#000",
	"error": "#b71c1c",
	"cancel": "#f75b4a",
	"success": "#7ed321"
};